import styled from 'styled-components'

export const PDFViewBox = styled.div`
    display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
`

PDFViewBox.Header = styled.div`
    background: rgb(82, 86, 89);
	color: var(--white);
	width: 100%;
	display: flex;
	flex-direction: row;
	/* flex-wrap: wrap; */
	align-items: center;
	justify-content: space-around;
	gap: 15px;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
`

PDFViewBox.HeaderLeft = styled.div`
    max-width: 140px;
	width: 100%;
	padding-left: 20px;
`

PDFViewBox.HeaderCenter = styled.div`
    display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	margin: 8px 0;
	width: 100%;

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-pdf-nav {
        color: var(--white);
        background: transparent;
        min-width: 0;
        padding: 0;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        transition: all ease .35s;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-pdf-nav.Mui-disabled.Mui-disabled {
        color: #a6a6a6;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-pdf-nav:hover {
        transition: all ease .35s;
        background: grey;
    }
`

PDFViewBox.PageNumbers = styled.div`

`

PDFViewBox.HeaderRight = styled.div`
    max-width: 140px;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-download-pdf-view {
        color: var(--white);
        background: transparent;
        min-width: 0;
        padding: 0;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        transition: all ease .35s;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-download-pdf-view:hover {
        transition: all ease .35s;
        background: grey;
    }
`

PDFViewBox.Document = styled.div`
    background: grey;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;

    /* .react-pdf__Page {
    }

    .react-pdf__Document {
        width: calc(100% - 322px);
        padding: 20px 20px 12px 20px;
    }

    canvas.react-pdf__Page__canvas {
        display: flex !important;
        margin: 0 !important;
        padding: 0 !important;
    } */

    canvas.react-pdf__Page__canvas {
        width: 100% !important;
        height: auto !important;
        display: flex !important;
        margin: 0 !important;
        padding: 0 !important;
        /* max-width: 744px; */
    }

    .react-pdf__Page {
        width: 100%;
        /* display: flex; */
        align-items: center;
        justify-content: center;
        /* max-width: 744px; */
    }

    .react-pdf__Document {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        /* max-width: 744px; */
    }

    .react-pdf__Page__annotations.annotationLayer {
        display: none;
    }

    .pdf-viewer-page-numbers {
        text-align: center;
    }
`

PDFViewBox.DocumentContent = styled.div`
    padding: 20px;
	max-width: 744px;
`